<template>
  <div class="Equipment-Expenses-Main">
    <div class="left-container">
      <div class="date-section">
        <div style="flex-grow: 1;">
          <span>Equipment Expenses Date</span>
          <DateTimePicker title="From" placeholder="From" :showTime="false" :isRequired="true" :errorMessage.sync="errorFromDate" :value.sync="selectedFromDate"/>
          <DateTimePicker title="To" placeholder="To" :showTime="false" :isRequired="true" :errorMessage.sync="errorToDate" :value.sync="selectedToDate"/>
        </div>
        <button @click="clickRefreshed">Refresh</button>
      </div>
      <div class="filter-table">
        <Filters class="filters-category" title="Equipment Category" :tableData="equipmentCategoryList" :selectedObject.sync="selectedEquipmentCategory" itemKey="CategoryCode"/>
        <Filters class="filters-team" title="Team" :tableData="teamList" :selectedObject.sync="selectedTeam" itemKey="Team"/>
        <Filters class="filters-workshop" title="Workshop" :tableData="workshopList" :selectedObject.sync="selectedWorkshop" itemKey="Supplier Code"/>
      </div>
    </div>
    <div class="right-container">
      <div class="filtered-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title-long">Date</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{injectedFromDate}} to {{injectedToDate}}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title-long">Equipment Category</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{filteredEquipmentCategory}}</div>
          </div>
        </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Team</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{filteredTeam}}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Workshop</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{filteredWorkshop}}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div>Last Refreshed : {{lastRefreshed}}</div>
        </div>
      </div>  
      <div class="chart-section">
        <div class="top-chart">
          <div class="barlinechart-title">Top 30 Part Group Expenses</div>
          <div class="barlineChart-PartgroupExpenses" id="barlineChart-PartgroupExpenses"></div> 
        </div>
        <div class="bottom-chart">
          <div class="barlinechart-title">Expenses by Equipment</div>
          <div class="barlineChart-EquipmentExpenses" id="barlineChart-EquipmentExpenses"></div> 
        </div>
      </div>
      
    </div>
    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="drillThroughClicked" ref="context"/>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {

      // Data for filters on the left container
      equipmentCategoryList: [],
      teamList: [],
      workshopList: [],

      // Error messages
      errorToDate: '',
      errorFromDate: '',

      // Selected value
      selectedFromDate: null,
      selectedToDate: null,
      selectedEquipmentCategory: [],
      selectedTeam: [],
      selectedWorkshop: [],

      // Filtered value
      filteredEquipmentCategory: '',
      filteredTeam: '',
      filteredWorkshop: '',

      // Call API 
      injectedToDate: null,
      injectedFromDate: null,
      injectedEquipmentCategory: '',
      injectedTeam: '',
      injectedWorkshop: '',

      // Last refresh time
      lastRefreshed: null,

      // data from API Call
      equipmentExpensesData: [],
      partgroupExpensesData: [],

      // Chart data
      partgroupExpensesChart: null,
      equipmentExpensesChart: null,

      // Drill Through
      showContextMenu: false,
      contextPosition: [100, 100],
      contextItems: [],

    }
  },
  props: {
  },
  methods: {
    drillThroughClicked: async function(item) {

      var dataToPost = {
        'startdate' : this.injectedFromDate,
        'enddate' : this.injectedToDate,
        'categoryarray' : this.injectedEquipmentCategory,
        'teamarray' : this.injectedTeam,
        'workshoparray' : this.injectedWorkshop,
        'rpttype' : 'EQUIPMENT_DETAILS',
      };

       sessionStorage.setItem(`Drill Through - Details ${item}`,
         JSON.stringify(
           {
             injectedFromDate: (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd'),
             injectedToDate: (new Date(this.selectedToDate)).formatString('yyyy-MM-dd'),
             injectedEquipmentCategory: this.injectedEquipmentCategory,
             injectedTeam: this.injectedTeam,
             injectedWorkshop: this.injectedWorkshop,
             filteredEquipmentCategory: this.filteredEquipmentCategory,
             filteredTeam: this.filteredTeam,
             filteredWorkshop: this.filteredWorkshop,
             lastRefreshed: this.lastRefreshed,
             title: item,
             data: dataToPost
            }
          ));

      var drillThroughLink = this.$router.resolve(`/Home/${this.$route['params']['user']}/Dashboard/Equipment Expenses/Drill Through - Details ${item}`);
      window.open(drillThroughLink.href, '_blank');
      sessionStorage.clear();
    },  
    refreshClearFilter: function() {
      this.injectedToDate = '';
      this.injectedFromDate = '';
      this.injectedEquipmentCategory = '';
      this.injectedTeam = '';
      this.injectedWorkshop = '';
    },
    errorDatePickerCheck: function() {
      if(this.selectedFromDate == null) {
        this.errorFromDate = 'Please pick a date';
        return true;
      }
      else if(this.selectedToDate == null) {
        this.errorToDate = 'Please pick a date';
        return true;
      }
      else if(this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
        this.errorFromDate = 'From Date > To Date';
        this.errorToDate = 'From Date > To Date';
        return true;
      }
      else
        return false;
    },
    createPartgroupExpensesChart: async function(partgroupExpensesData) {
      if(partgroupExpensesData.includes('error')) {
        document.getElementById('barlineChart-PartgroupExpenses').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(partgroupExpensesData.length == 0) {
        document.getElementById('barlineChart-PartgroupExpenses').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else {
        // Chartist Top Bar Chart 
        // Data
        const labels = partgroupExpensesData.map((m) => { return m['Part Group']}); 
        const series = partgroupExpensesData.map((m) => { return m['Amount']});

        // Configuration of Bar Chart
        var options = {
          chartPadding: {top: 20, right: 20, bottom: 20, left: 20},
          height: 350,
          seriesBarDistance: 10,
          axisX: {
            labelOffset: {
              x: 0,
              y: 15
            },
          },
          axisY: {
            showLabel: true,
          }
        }

        // Create Chartist Bar Chart
        // X-axis = labels Y-axis = series
        this.PartgroupExpensesChart = new Chartist.Bar('.barlineChart-PartgroupExpenses', {
              labels: labels,
              series: [series]
        }, options);
      }

      // Context Menu for Drill Through report
        var mainContainer = this;
        $('document').ready(() => {
          $(document).on('click', '.barlineChart-PartgroupExpenses .ct-bar', function(e) {
            mainContainer.showContextMenu = true;
            mainContainer.contextItems = ['Top 30 Part Group Expenses', 'Expenses by Part Type Summary'];
            
            mainContainer.$nextTick(() => {
              mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight-40), e.clientX + 15];
            });
          });
        });
    },
    createEquipmentExpensesChart: async function(equipmentExpensesData) {
      if(equipmentExpensesData.includes('error')) {
        document.getElementById('barlineChart-EquipmentExpenses').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(equipmentExpensesData.length == 0) {
        document.getElementById('barlineChart-EquipmentExpenses').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else {
        // Chartist Bottom Bar Chart
        // Data
        const labels = equipmentExpensesData.map((m) => { return m['Equipment Number']}); 
        const series = equipmentExpensesData.map((m) => { return m['Amount']});

        // Configuration of Bar Chart
        var options = {
          chartPadding: {top: 20, right: 20, bottom: 20, left: 20},
          height: 350,
          axisX: {
            labelOffset: {
              x: 0,
              y: 15
            },
            showLabel: true,
          }
        }

        // Create Chartist Bar Chart
        // labels = X-axis series = Y-axis
        this.equipmentExpensesChart = new Chartist.Bar('.barlineChart-EquipmentExpenses', {
              labels: labels,
              series: [series],
        }, options);
      }

      // Context Menu for Drill Through report
        var mainContainer = this;
        $('document').ready(() => {
          $(document).on('click', '.barlineChart-EquipmentExpenses .ct-bar', function(e) {
            mainContainer.showContextMenu = true;
            mainContainer.contextItems = ['Expenses by Equipment Summary', '​Expenses by Equipment Details'];
            
            mainContainer.$nextTick(() => {
              mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight-40), e.clientX + 15];
            });
          });
        });
    },
    refreshclearChart: async function() {
      $('#barlinechart-EquipmentExpenses').html('');
      $('#barlinechart-PartgroupExpenses').html('');

      if(this.chartBar)
        this.chartBar.detach();
      if(this.chartBar2)
        this.chartBar2.detach();
    },
    
    clickRefreshed: async function() {
      // Check date input
      if(this.errorDatePickerCheck())
        return;

      this.refreshClearFilter();
      this.refreshclearChart();
      // this.$fullscreenLoading("Refreshing");
      this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

      // Display all selected items in filter bar (top container) 
      this.filteredEquipmentCategory = (
        this.selectedEquipmentCategory.length > 0 ?
        this.selectedEquipmentCategory.map((category) => {
          return category["CategoryCode"];
        }).join(", ") : "All"
      );

      this.filteredTeam = (
        this.selectedTeam.length > 0 ?
        this.selectedTeam.map((team) => {
          return team["Team"];
        }).join(", ") : "All"
      );

      this.filteredWorkshop = (
        this.selectedWorkshop.length > 0 ?
        this.selectedWorkshop.map((supplier) => {
          return supplier["Supplier Code"];
        }).join(", ") : "All"
      );

      // Data to call API
      this.injectedEquipmentCategory = (
        this.selectedEquipmentCategory.length > 0 ?
        this.selectedEquipmentCategory.map((category) => {
          return category["CategoryCode"];
        }).join(", ") : ""
      );

      this.injectedTeam = (
        this.selectedTeam.length > 0 ?
        this.selectedTeam.map((team) => {
          return team["Team"];
        }).join(", ") : ""
      );

      this.injectedWorkshop = (
        this.selectedWorkshop.length > 0 ?
        this.selectedWorkshop.map((supplier) => {
          return supplier["Supplier Code"];
        }).join(", ") : ""
      );

      this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
      this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

      document.getElementById('barlineChart-PartgroupExpenses').innerHTML= "";
      document.getElementById('barlineChart-EquipmentExpenses').innerHTML="";

      this.$fullscreenLoading("Getting Chart");
      
      this.equipmentExpensesData = 
      await this.$apiCallV2(`/EquipmentExpenses/GetEMSExpenses?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&teamarray=${this.injectedTeam}&categoryarray=${this.injectedEquipmentCategory}&workshoparray=${this.injectedWorkshop}&rpttype=BY_EQUIPMENT`);

      this.partgroupExpensesData = 
      await this.$apiCallV2(`/EquipmentExpenses/GetEMSExpenses?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&teamarray=${this.injectedTeam}&categoryarray=${this.injectedEquipmentCategory}&workshoparray=${this.injectedWorkshop}&rpttype=BY_PARTGROUP&showtopx=30`);

      this.$nextTick(async () => await this.createPartgroupExpensesChart(this.partgroupExpensesData));
      this.$nextTick(async () => await this.createEquipmentExpensesChart(this.equipmentExpensesData));

      this.$fullscreenLoading();  
    },
  },
  async mounted() {
    this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0); 

    this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
    this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

    // API Calls for getting data for filters
    this.$fullscreenLoading('Getting Vehicle Category');
    this.equipmentCategoryList = await this.$apiCallV2('/EquipmentExpenses/GetVehicleCategory');

    this.$fullscreenLoading('Getting Team');
    this.teamList = await this.$apiCallV2('/EquipmentExpenses/GetListMaster?masterfile=team');

    this.$fullscreenLoading('Getting Workshop');
    this.workshopList = await this.$apiCallV2('/EquipmentExpenses/GetListMaster?masterfile=supplier');
    
    this.clickRefreshed();

    this.$fullscreenLoading();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Equipment-Expenses-Main {
    display: flex;
    padding: 5px 5px 5px 45px;
    width: 100%;
    height: 100%;
    font-size: 12px;

  > .left-container {
    height: 100%;
    min-width: 300px;
    max-width: 300px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;
    position: relative;
    overflow: hidden;

    > .date-section{
      height: 80px;
      display: flex;
      align-items: center;
      padding: 10px 5px 0 5px;
    }

    > .filter-table{
      width: 100%; 
      height: calc(100% - 125px); 
      flex-grow: 1;

      > .filters-category {
        width: 100%; 
        height: 33%;
        padding: 5px 5px 0 5px;
      }

      > .filters-team, .filters-workshop {
        width: 100%; 
        height: 33%;
        padding: 0 5px 0 5px;
      }
    }
  }

  > .right-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    > .filtered-section {
      width: 100%;  
      height: auto;
      background-color: white;
      border-radius: 5px;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 8;
      display: flex;
      align-items: center;
      margin-bottom: 3px;
      overflow-x: auto;
      overflow-y: hidden;

      > .filtered-items {
        width: calc(100% - 250px);

        > .filtered-row {
          display: flex;
          align-items: center;

          > .filter-title-long {
            width: 270px;
            padding-left:3px;
          }
          > .filter-title {
            width: 120px;
            padding-left:3px;
          }
          > .colon-seperator {
            margin: 0 5px;
          }
          > .filter-details {
            width: 100%;
          }
        }
      }

      > .refresh-section {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          margin-right: 3px;
      }
    }

    > .chart-section {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;

      > .top-chart {
        width:100%;
        margin-bottom: 4px;
        background-color: white;
        border-radius: 5px;
        height: 100%;
        position: relative;

        > .barlinechart-title {
          height: auto;
          width:  calc( 100% - 10px);
          margin-top: 5px;
          margin-left: 10px;
          font-size: 12px;
          color: black;
          font-weight: bold;
        }

        > .barlineChart-PartgroupExpenses {
          margin-top: 20px;
          height: auto;
          padding-left: 5px;
          padding-right: 5px;
        }
      }

      > .bottom-chart {
        width: 100%;
        background-color: white;
        border-radius: 5px;
        height: 100%;
        position: relative;
        
        > .barlinechart-title {
          height: auto;
          width:  calc( 100% - 10px);
          margin-top: 5px;
          margin-left: 10px;
          font-size: 12px;
          color: black;
          font-weight: bold;
        }

        > .barlineChart-EquipmentExpenses {
          margin-top: 20px;
          padding-left: 5px;
          height: auto;
          padding-right: 5px;
        }
      }
    }
  }
}

</style>